/* eslint-disable */

import { fork, all, takeEvery, put } from 'redux-saga/effects';
import _ from 'lodash';
import { GET_ITEMS, GET_ITEMS_SUCCESS, GET_ITEMS_FAIL } from './redux';
import Request from 'app/utils/xhrWrapper';

export function* getItems() {
  yield takeEvery(GET_ITEMS, function* (action) : any {
    try {
      const response = yield Request.get(`movie/movie/loadmore/tagid/${_.get(action, ['data', 'id'])}/more_type/infinity/show_serial_parent/1/perpage/40/page/${_.get(action, ['data', 'page'])}`);
      const data = _.get(response, ['data', '0']);
      if (_.get(data, ['movies', 'data'])) {
        yield put({
          type: GET_ITEMS_SUCCESS,
          data: {
            movies: _.get(data, ['movies', 'data']),
            hasNextPage: _.get(data, ['more_type']) === 'infinity' ? _.get(data, ['links', 'more_records']) : !!_.get(data, ['links', 'next']),
            pageTitle: _.get(data, 'link_text'),
          },
        });
      } else {
        yield put({ type: GET_ITEMS_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: GET_ITEMS_FAIL, data: error });
    }
  });
}

export default function* () {
  yield all([
    fork(getItems),
  ]);
}
